export default __webpack_public_path__ + "static/media/favicon-96x96.5992504d.png";